module.exports = __webpack_public_path__ + "img/feat_3.dae339b4.png";